<template>
	<div class="user-coupon">
		<div class="user-coupon-contents">
			<div class="user-coupon-contents__top">
				<h2 class="user-coupon-contents__name">{{ item.couponName }}</h2>
				<p class="user-coupon-contents__amt">{{ couponAmt }}</p>
				<p class="user-coupon-contents__code">{{ item.couponNo }}</p>
			</div>

			<div class="user-coupon-contents__bottom">
				<p class="user-coupon-contents__date">유효기간 : {{ couponPeriod }}</p>
				<p class="user-coupon-contents__date">
					사용기한 : {{ couponPeriodDays }}
				</p>
			</div>
		</div>
		<div :class="userCouponLabelByType">
			<div class="user-coupon-label__label">
				<div>H</div>
				<div>I</div>
				<div>M</div>
				<div>O</div>
				<div class="hyphen">-</div>
				<div>C</div>
				<div>O</div>
				<div>U</div>
				<div>P</div>
				<div>O</div>
				<div>N</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	numberWithCommas,
	formatDate,
	formatDateString,
	diffDateDays,
} from '@/utils/util';

export default {
	props: {
		item: {
			type: Object,
			default: () => {},
			required: true,
		},
	},
	computed: {
		couponAmt() {
			return numberWithCommas(this.item.couponAmt);
		},
		fromDateStr() {
			return formatDateString(this.item.couponFrDt, '-');
		},
		toDateStr() {
			return formatDateString(this.item.couponToDt, '-');
		},
		couponGrad() {
			return this.item.couponGrad ? this.item.couponGrad.toUpperCase() : '';
		},
		couponPeriod() {
			return `${this.fromDateStr} ~ ${this.toDateStr}`;
		},
		nowDateStr() {
			return formatDate(new Date(), '-');
		},
		couponPeriodDays() {
			return `${diffDateDays(this.nowDateStr, this.toDateStr)}일 남음`;
		},
		userCouponLabelByType() {
			const classNameList = ['user-coupon-label'];

			if (this.couponGrad === 'S') {
				classNameList.push('user-coupon-label--silver');
			}
			if (this.couponGrad === 'G') {
				classNameList.push('user-coupon-label--gold');
			}
			if (this.couponGrad === 'P') {
				classNameList.push('user-coupon-label--platinum');
			}
			if (this.couponGrad === 'D') {
				classNameList.push('user-coupon-label--diamond');
			}

			return classNameList;
		},
	},
};
</script>

<style scoped>
.user-coupon {
	--border-color: #c8c8c8;
	--label-width: 54px;
	--circle-width: 24px;
	position: relative;
	min-height: 200px;
	background: #f2f2f2;
	overflow: hidden;
}

.user-coupon::before,
.user-coupon::after {
	content: '';
	position: absolute;
	z-index: 1;
	right: calc(var(--label-width) - (var(--circle-width) / 2));
	width: var(--circle-width);
	height: calc(var(--circle-width) / 2);
	border-radius: calc(var(--circle-width) / 2);
	border: 1px solid var(--border-color);
	background: #fff;
}

.user-coupon::before {
	top: 0;
	border-top-left-radius: 0;
	border-top-right-radius: 0;
	border-top-color: #fff;
}

.user-coupon::after {
	bottom: 0;
	border-bottom-left-radius: 0;
	border-bottom-right-radius: 0;
	border-bottom-color: #fff;
}

.user-coupon-contents {
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	display: flex;
	flex-flow: column nowrap;
	justify-content: space-between;
	width: calc(100% - var(--label-width));
	padding: 1.125rem;
	border: 1px solid var(--border-color);
	border-right: 0;
}

.user-coupon-contents__name {
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	font-size: 0.975rem;
	font-weight: 500;
	letter-spacing: -0.05em;
}

.user-coupon-contents__amt {
	font-family: 'Gmarket Sans', sans-serif;
	font-size: 2.5rem;
	font-weight: 500;
	line-height: 1.2;
}

.user-coupon-contents__code {
	font-family: 'Gmarket Sans', sans-serif;
	font-size: 0.875rem;
	font-weight: 300;
	word-break: break-all;
}

.user-coupon-contents__date {
	color: #666;
	font-size: 0.8125rem;
	font-weight: 300;
}

.user-coupon-label {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	width: var(--label-width);
	border: 1px solid var(--border-color);
	border-left: 0;
	background: #222;
}

.user-coupon-label--silver {
	background: #a8a8a8;
}

.user-coupon-label--gold {
	background: #cead61;
}

.user-coupon-label--platinum {
	background: #716597;
}

.user-coupon-label--diamond {
	background: #2b98a0;
}

.user-coupon-label__label {
	color: #fff;
	font-family: serif;
	font-size: 0.625rem;
	line-height: 1.3;
	text-align: center;
}

.user-coupon-label__label > div {
	transform: rotate(90deg);
}

.user-coupon-label__label > div.hyphen {
	padding: 0.25rem 0;
}
</style>
